<template>
	<div class="login">
		<div class="login-box flex">
			<div class="login-title tc">
				欢迎登录<br>
				新路线系统
			</div>
			<!-- form -->
			<div class="login-form tc" @keyup.enter="submitForm('ruleForm')">
				<img class="logo" src="@/assets/images/logo-max.png" alt="">
				<el-form class="form-box-login" :model="form" :rules="rules" ref="ruleForm">
					<el-form-item prop="name">
						<el-input v-model.trim="form.name" placeholder="请输入账号"></el-input>
					</el-form-item>
					<el-form-item class="mt40" prop="password">
						<el-input v-model.trim="form.password" placeholder="请输入密码" type="password"></el-input>
					</el-form-item>
					<el-form-item class="login-btn-box">
						<el-button class="login-btn" @click="submitForm('ruleForm')">登录</el-button>
					</el-form-item>
				</el-form>
			</div>
			<!--  -->
		</div>

	</div>
</template>
<script>
	import {
		debounce
	} from '@/utils/debounce'
	export default {
		data() {
			return {
				form: {
					name: "",
					password: ""
				},
				rules: {
					name: [{
						required: true,
						message: '请输入账号',
						trigger: 'blur'
					}, ],
					password: [{
						required: true,
						message: '请输入密码',
						trigger: 'change'
					}],
				}
			}
		},
		created() {
			this.form.name = window.localStorage.getItem('code') ? window.localStorage.getItem('code') : '';
			this.form.password = window.localStorage.getItem('password') ? window.localStorage.getItem('password') : '';
		},
		methods: {
			submitForm: debounce(function (formName) {
				// 防止token失效弹出多个提示弹窗
				window.axiosCancel = false;
				this.$refs[formName].validate((valid) => {
					if (valid) {

						let that = this;
						that.$request.post(
								"login",
								true, {
									code: that.form.name,
									pass: that.form.password
								}
							)
							.then((res) => {
								window.localStorage.setItem('code',that.form.name);
								window.localStorage.setItem('password',that.form.password);
								if (res) {
									window.sessionStorage.setItem('token', res.data.token);
									window.sessionStorage.setItem('groupId', res.data.userDetail.groupId);
									window.sessionStorage.setItem('groupName', res.data.userDetail.groupName);
									window.sessionStorage.setItem('userInfo', JSON.stringify(res.data
										.userDetail.sysUser));
									window.sessionStorage.setItem('roles', JSON.stringify(res.data
										.userDetail.roles));
									window.sessionStorage.setItem('perms', JSON.stringify(res.data
										.userDetail.perms));
									window.sessionStorage.setItem('currentName','home');
									window.sessionStorage.setItem('roleType',res.data.userDetail.role.roleType);
									window.sessionStorage.setItem('initPassFlag', res.data.userDetail.initPassFlag?1:0);
								   window.sessionStorage.setItem('passwordExpiry',res.data.userDetail.passwordExpiry?res.data.userDetail.passwordExpiry:0);
									// permType  数据权限标示：0:浏览  1:编辑
									window.sessionStorage.setItem('isEdit',res.data.userDetail.permType);
									window.sessionStorage.setItem("menuButtenList",JSON.stringify(res.data.userDetail.sysMenuButtonlist))
									that.$router.push({
										name: 'home'
									})
									// this.getMenuList()

								}
							})
					} else {
						return false;
					}
				});
			}, 500,true),
			// 获取菜单列表
			getMenuList(){
				let that = this
				that.$request.post(
							"menuList",
							true, {}
						)
						.then((res) => {
							if (res) {
								sessionStorage.setItem("menuList",JSON.stringify(res.data))
							}
				})
			},
		}
	}

</script>
<style lang="scss" scoped>
	.login {
		width: 100%;
		height: 100%;
		background: url("../../assets/images/login_bg.jpg");
		background-size: 100% 100%;
		padding-top: 80px;
		box-sizing: border-box;
		min-width: 960px;
		min-height: 580px;

		.login-box {
			width: 90%;
			box-sizing: border-box;
			margin: auto;

			.login-title {
				width: 38%;
				font-size: 50px;
				font-weight: normal;
				color: #FFFFFF;
				line-height: 80px;
				padding-top: 90px;
			}

			.login-form {
				flex: 1;

				.logo {
					width: 200px;
					margin-top: 100px;
				}

				.form-box-login {
					width: 500px;
					margin: 60px auto 0;

					/deep/ .el-input__inner {
						width: 100%;
						height: 60px;
						background: #F4F8F7;
						border-radius: 8px;
						padding-left: 15px;
						border: none;
						font-size: 20px;
						color: #9289A6;

						&::placeholder {
							font-size: 20px;
							color: #9289A6;
						}
					}

					.login-btn-box {
						margin-top: 65px;
					}

					.login-btn {
						width: 100%;
						height: 60px;
						background: #3AAAA8;
						box-shadow: 0px 5px 15px 0px rgba(58, 170, 168, 0.5);
						border-radius: 40px;
						font-size: 26px;
						font-weight: 400;
						color: #FFFFFF;
						line-height: 60px;
						padding: 0;

					}
				}
			}
		}

	}

</style>
<style lang="scss" scoped>
	/* 小于 1367px 大于max-height: 626px*/
	@media screen and (max-width:1367px) and (max-height: 626px) {
		.login {
			padding-top: 60px !important;
		}

		.login-title {
			font-size: 40px !important;
			line-height: 60px !important;
			padding-top: 80px !important;
		}

		.logo {
			margin-top: 40px !important;
		}

		.form-box-login {
			width: 420px !important;
			margin: 40px auto 0 !important;
		}

		.login-btn-box {
			margin-top: 45px !important;
		}
	}
	/* 小于 1367px*/
	@media screen and (max-height:580px) {
		/* .login-title {
			font-size: 40px !important;
			line-height: 60px !important;
			padding-top: 60px !important;
		} */
			.logo {
			margin-top: 20px !important;
		}
		.form-box-login {
			width: 380px !important;
			margin: 20px auto 0 !important;
		}
		.login-btn-box {
			margin-top: 35px !important;
		}
	}

</style>
